import React, { createContext, useContext, useState } from 'react';

const NavbarContext = createContext();

export const NavbarProvider = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <NavbarContext.Provider value={{ collapsed, setCollapsed }}>
      {children}
    </NavbarContext.Provider>
  );
};

export const useNavbar = () => useContext(NavbarContext);